export default {
  id: 'molten.generic.Exists.ComparatorFilterConverter',
  type: 'generic.Exists',
  convert: (cmp, attribute) => {
    return {
      type: 'exists',
      field: attribute.blueprint.field
    };
  }
};